module.exports = __webpack_public_path__ + "media/src/whalewisdom/assets/images/main-logo-7f112be0917633c94500d91d16bb96e5.png";